import { render, staticRenderFns } from "./TaoCan.vue?vue&type=template&id=f5426716&scoped=true&"
import script from "./TaoCan.vue?vue&type=script&lang=js&"
export * from "./TaoCan.vue?vue&type=script&lang=js&"
import style0 from "./TaoCan.vue?vue&type=style&index=0&id=f5426716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5426716",
  null
  
)

export default component.exports